import { atom } from 'recoil';

export const OAuthData = atom({
	// user의 로그인 정보를 담음
	key: 'OAuthData',
	default: null,
});

export const OAuthDataState = atom({
	// user의 OAuth 접속 상태 확인
	key: 'OAuthDataState',
	default: false,
});

export const WalletState = atom({
	key: 'WalletState',
	default: false,
});
